import PropTypes from 'prop-types';
var userShape = PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    password: PropTypes.string,
    is_working: PropTypes.bool.isRequired,
});
export default userShape;
